import React from 'react'
import { ButtonDep as Button } from '..'

const Head = ({ title, showHideFilter }: { title: string; showHideFilter?: () => void }) => {
  return (
    <div className='d-flex justify-content-between align-items-center'>
      <div className='d-flex justify-content-between pb-3'>
        <div className='d-flex'>
          <h2>{title}</h2>
        </div>
      </div>
      {showHideFilter && <Button label='Filter' type='secondary' icon='filter' onClick={showHideFilter} />}
    </div>
  )
}

export default Head
